import { Link } from "react-router-dom";

export const Logo = ({ to = "/", compact = false }) => (
  <Link to={to} data-testid="brand-logo" className="group flex items-center gap-3 shrink-0">
    <span className="flex h-16 w-16 items-center justify-center rounded-xl border border-amber-400/30 bg-[#0a0a0c] transition-colors duration-300 group-hover:border-amber-400/70">
      <img src="/logo-mark.png" alt="Luxury Rideshare" width="56" height="56" className="h-14 w-14 object-contain" />
    </span>
    <span className={`flex-col leading-none ${compact ? "hidden sm:flex" : "flex"}`}>
      <span className="font-serif text-[1.05rem] font-semibold tracking-[0.14em] text-amber-50 sm:text-lg">LUXURY</span>
      <span data-testid="brand-logo-rideshare" className="mt-1 text-[1.16rem] font-semibold leading-none tracking-[0.12em] text-amber-400/90">RIDESHARE</span>
    </span>
  </Link>
);
